module.exports = __webpack_public_path__ + "img/full3-min.c6513a3b.png";